import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Layout from "../../components/Layout";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Spinner from "react-bootstrap/Spinner";
import { InputMask } from "@react-input/mask";
import "./style.css";

const OrganizationDetail = () => {
	const { id } = useParams();
	const navigate = useNavigate();

	const [loading, setLoading] = useState(true);
	const [btnDisabled, setBtnDisabled] = useState(false);
	const [showSpinner, setShowSpinner] = useState(false);

	const [organisationName, setOrganisationName] = useState("");
	const [organisationMail, setOrganisationMail] = useState("");
	const [organisationPhone, setOrganisationPhone] = useState("");
	const [organisationAuthorizedPerson, setOrganisationAuthorizedPerson] =
		useState([""]);
	const [organisationFloors, setOrganisationFloors] = useState("");
	const [organisationRooms, setOrganisationRooms] = useState("");
	const [organisationBilling, setOrganisationBilling] = useState("");
	const [organisationActive, setOrganisationActive] = useState("Aktif");
	const [organisationType, setOrganisationType] = useState("");
	const [organisationInfoVisible, setOrganisationInfoVisible] = useState(true);
	const [organisationBasements, setOrganisationBasements] = useState("");
	const [users, setUsers] = useState([]);

	const getUsers = async () => {
		try {
			const response = await fetch(`https://app.vivasmartcare.com/api/panel-users`);
			const usersData = await response.json();
			setUsers(usersData);
		} catch (error) {
			console.error("Kullanıcı verileri getirilirken bir hata oluştu:", error);
		}
	};

	const getOrganization = async () => {
		try {
			const response = await fetch(`https://app.vivasmartcare.com/api/organisation/${id}`);
			if (response.ok) {
				const orgData = await response.json();
				setOrganisationName(orgData.organisationName || "");
				setOrganisationMail(orgData.organisationMail || "");
				setOrganisationPhone(orgData.organisationPhone || "");
				// API'den gelen veriyi string array formatına çevir
				let authorizedPersons = [];
				if (
					orgData.organisationAuthorizedPerson &&
					orgData.organisationAuthorizedPerson.length > 0
				) {
					// Eğer object array formatındaysa string array'e çevir
					if (
						typeof orgData.organisationAuthorizedPerson[0] === "object" &&
						orgData.organisationAuthorizedPerson[0].type !== undefined
					) {
						authorizedPersons = orgData.organisationAuthorizedPerson.map(
							(person) => person.type || ""
						);
					} else {
						// Eğer zaten string array ise olduğu gibi kullan
						authorizedPersons = orgData.organisationAuthorizedPerson;
					}
				} else {
					authorizedPersons = [""];
				}
				setOrganisationAuthorizedPerson(authorizedPersons);
				setOrganisationFloors(orgData.organisationFloors || "");
				setOrganisationRooms(orgData.organisationRooms || "");
				setOrganisationBilling(orgData.organisationBilling || "");
				setOrganisationActive(orgData.organisationActive || "Aktif");
				setOrganisationType(orgData.organisationType || "");
				setOrganisationInfoVisible(orgData.organisationInfoVisible !== false);
				setOrganisationBasements(orgData.organisationBasements || "");
			} else {
				alert("Kurum bulunamadı");
				//navigate("/organizations");
			}
		} catch (error) {
			console.error("Kurum verileri getirilirken bir hata oluştu:", error);
			alert("Kurum verileri yüklenirken bir hata oluştu");
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		if (id) {
			getOrganization();
			getUsers();
		}
	}, [id]);

	const handleUpdate = async (e) => {
		e.preventDefault();

		// Tekrarlanan kişileri kontrol et ve temizle
		const uniquePersons = organisationAuthorizedPerson.filter(
			(person, index, self) => {
				// Boş değerleri geç
				if (!person || person.trim() === "") return false;
				// İlk bulunan index'i kontrol et (tekrar edenleri filtrele)
				return self.indexOf(person) === index;
			}
		);

		// Eğer tekrarlanan kişi varsa uyarı ver
		const nonEmptyPersons = organisationAuthorizedPerson.filter(
			(p) => p && p.trim() !== ""
		);
		if (uniquePersons.length !== nonEmptyPersons.length) {
			alert("Tekrarlanan kişiler kaldırıldı. Lütfen kontrol edin.");
			setOrganisationAuthorizedPerson(uniquePersons);
			return;
		}

		setBtnDisabled(true);
		setShowSpinner(true);

		try {
			// Boş değerleri filtrele
			const filteredPersons = uniquePersons.filter(
				(p) => p && p.trim() !== ""
			);

			const response = await fetch("https://app.vivasmartcare.com/api/organisation", {
				method: "PUT",
				body: JSON.stringify({
					id,
					organisationName,
					organisationMail,
					organisationPhone,
					organisationAuthorizedPerson: filteredPersons,
					organisationFloors,
					organisationRooms,
					organisationBilling,
					organisationAuthorizedPersonActive: "",
					organisationActive,
					organisationType,
					organisationInfoVisible,
					organisationBasements,
				}),
				headers: { "Content-Type": "application/json" },
			});

			if (response.ok) {
				alert("Kurum Güncellendi");
				navigate("/organizations");
			} else {
				alert("Kurum güncellenirken bir hata oluştu");
			}
		} catch (error) {
			console.error("Güncelleme işlemi sırasında bir hata oluştu:", error);
			alert("Kurum güncellenirken bir hata oluştu");
		} finally {
			setBtnDisabled(false);
			setShowSpinner(false);
		}
	};

	if (loading) {
		return (
			<Layout>
				<div
					className="user-modal-inputs"
					style={{ textAlign: "center", padding: "50px" }}
				>
					<Spinner animation="border" variant="primary" />
				</div>
			</Layout>
		);
	}

	return (
		<Layout>
			<div className="user-modal-inputs">
				<Form onSubmit={handleUpdate}>
					<Form.Group>
						<label className="mb-2">Kurum Adı:</label>
						<Form.Control
							type="text"
							placeholder="Kurum Adı Giriniz"
							value={organisationName}
							required
							onChange={(e) => setOrganisationName(e.target.value)}
						/>
					</Form.Group>
					<Form.Group>
						<label className="mb-2">Kurum Tipi:</label>
						<Form.Select
							value={organisationType}
							required
							onChange={(e) => setOrganisationType(e.target.value)}
						>
							<option value="">Kurum Tipi Seçiniz</option>
							<option value="Bireysel">Bireysel</option>
							<option value="Kurumsal">Kurumsal</option>
						</Form.Select>
					</Form.Group>
					<Form.Group>
						<label className="mb-2">Kurum E-posta:</label>
						<Form.Control
							type="email"
							placeholder="E-posta Adresi Giriniz"
							value={organisationMail}
							onChange={(e) => setOrganisationMail(e.target.value)}
						/>
					</Form.Group>
					<Form.Group>
						<label className="mb-2">Kurum Telefon:</label>
						<InputMask
							mask="+90__________"
							replacement={{ _: /\d/ }}
							value={organisationPhone}
							showMask
							onChange={(e) => setOrganisationPhone(e.target.value)}
							className="form-control"
							placeholder="Telefon No Giriniz"
						/>
					</Form.Group>
					<Form.Group>
						<label className="mb-2">Yetkili Kişi:</label>
						{organisationAuthorizedPerson.map((person, index) => (
							<div
								key={index}
								style={{ display: "flex", gap: "10px", marginBottom: "10px" }}
							>
								<Form.Select
									value={person || ""}
									onChange={(e) => {
										const selectedPerson = e.target.value;
										// Eğer seçilen kişi zaten başka bir yerde kullanılıyorsa uyarı ver
										if (
											selectedPerson &&
											organisationAuthorizedPerson.some(
												(p, i) => i !== index && p === selectedPerson
											)
										) {
											alert("Bu kişi zaten eklenmiş!");
											return;
										}
										const newPersons = [...organisationAuthorizedPerson];
										newPersons[index] = selectedPerson;
										setOrganisationAuthorizedPerson(newPersons);
									}}
									style={{ flex: 1 }}
								>
									<option value="">Yetkili Kişi Seçiniz</option>
									{users.map((user) => {
										// Bu select'teki kişi hariç, diğer select'lerde seçili olan kişileri gösterme
										const usedInOtherSelects =
											organisationAuthorizedPerson.some(
												(p, i) => i !== index && p === user.username
											);
										if (usedInOtherSelects) return null;
										return (
											<option
												value={user.username}
												key={user._id || user.username}
											>
												{user.username}
											</option>
										);
									})}
								</Form.Select>
								{organisationAuthorizedPerson.length > 1 && (
									<Button
										variant="danger"
										size="sm"
										type="button"
										onClick={() => {
											const newPersons = organisationAuthorizedPerson.filter(
												(_, i) => i !== index
											);
											setOrganisationAuthorizedPerson(newPersons);
										}}
									>
										Sil
									</Button>
								)}
							</div>
						))}
						<Button
							variant="outline-secondary"
							size="sm"
							type="button"
							onClick={() => {
								// Eğer tüm kullanıcılar zaten eklenmişse uyarı ver
								const allUsersAdded = users.every((user) =>
									organisationAuthorizedPerson.includes(user.username)
								);
								if (users.length > 0 && allUsersAdded) {
									alert("Tüm kullanıcılar zaten eklenmiş!");
									return;
								}
								setOrganisationAuthorizedPerson([
									...organisationAuthorizedPerson,
									"",
								]);
							}}
							style={{ marginTop: "10px" }}
						>
							+ Yetkili Kişi Ekle
						</Button>
					</Form.Group>
					<Form.Group>
						<label className="mb-2">Kat Sayısı:</label>
						<Form.Control
							type="number"
							placeholder="Kat Sayısı Giriniz"
							value={organisationFloors}
							required
							onChange={(e) => setOrganisationFloors(e.target.value)}
							min="1"
						/>
					</Form.Group>
					<Form.Group>
						<label className="mb-2">Oda Sayısı:</label>
						<Form.Control
							type="number"
							placeholder="Oda Sayısı Giriniz"
							value={organisationRooms}
							required
							onChange={(e) => setOrganisationRooms(e.target.value)}
							min="1"
						/>
					</Form.Group>
					<Form.Group>
						<label className="mb-2">Bodrum Katı:</label>
						<Form.Control
							type="number"
							placeholder="Bodrum Katı Sayısı Giriniz"
							value={organisationBasements}
							onChange={(e) => setOrganisationBasements(e.target.value)}
						/>
					</Form.Group>
					<Form.Group>
						<label className="mb-2">Faturalama:</label>
						<Form.Control
							type="text"
							placeholder="Faturalama Bilgisi Giriniz"
							value={organisationBilling}
							onChange={(e) => setOrganisationBilling(e.target.value)}
						/>
					</Form.Group>
					<Form.Group>
						<label className="mb-2">Kurum Durumu:</label>
						<Form.Select
							value={organisationActive}
							onChange={(e) => setOrganisationActive(e.target.value)}
						>
							<option value="Aktif">Aktif</option>
							<option value="Pasif">Pasif</option>
						</Form.Select>
					</Form.Group>
					<Form.Group>
						<Form.Check
							type="switch"
							id="organisation-info-visible"
							label={
								organisationInfoVisible
									? "Bilgileri Göster: Açık"
									: "Bilgileri Göster: Kapalı"
							}
							checked={organisationInfoVisible}
							onChange={(e) => setOrganisationInfoVisible(e.target.checked)}
							className="mt-2"
						/>
					</Form.Group>
					<div className="button-wrapper">
						<Button
							variant="secondary"
							type="button"
							onClick={() => navigate("/organizations")}
						>
							İptal
						</Button>
						<Button variant="primary" type="submit" disabled={btnDisabled}>
							{showSpinner ? (
								<>
									<Spinner
										animation="border"
										size="sm"
										style={{ marginRight: "8px" }}
									/>
									Güncelleniyor...
								</>
							) : (
								"Güncelle"
							)}
						</Button>
					</div>
				</Form>
			</div>
		</Layout>
	);
};

export default OrganizationDetail;
